<template>
  <!-- table组件 -->
  <div class="my_table_components">
    <el-table :data="tableObj.list" class="my-table" :style="'width: 100%;'" ref="multipleTable">
      <!-- 选择 -->
      <el-table-column type="selection" width="50" label="全选" v-if="tableObj.table_selection"></el-table-column>
      <!--遍历列-->
      <el-table-column
        v-for="(item,idx) in tableObj.table_detail"
        :key="idx"
        :label="item.label"
        :width="item.width?item.width:''"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="item.formatter" class="ellipsis-text">
            <div v-html="item.formatter(scope.row)"></div>
          </div>
          <div v-else class="ellipsis-text">
            <span>{{scope.row[item.prop]}}</span>
          </div>
        </template>
      </el-table-column>

      <!--操作列-->
      <el-table-column
        label="操作"
        :width="tableObj.btnsWidth"
        header-align="center"
        align="center"
        v-if="tableObj.btns.length"
      >
        <template slot-scope="scope" class="s">
          <template v-for="(val,index) in tableObj.btns">
            <div
              class="table_btn"
              @click="handleClick(scope.row,val,scope.$index)"
              v-if="(!val.formatter || val.formatter(scope.row))"
            >{{val.name}}</div>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!--页码-->
    <div class="block" v-if="!tableObj.layerpageinfo.hide">
      <div></div>
      <div class="page" v-if="tableObj.layerpageinfo.total > tableObj.layerpageinfo.pageSize">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="tableObj.layerpageinfo.pageNo"
          :page-size="tableObj.layerpageinfo.pageSize"
          layout="total, prev, pager, next"
          :total="tableObj.layerpageinfo.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableObj: {
      type: Object
    }
  },
  data() {
    return {
      visible: true,
      defaultHeight: "auto"
      // tableObj: {
      //   list: [],//列表数据
      //   btnsWidth: '120px',  //按钮宽度
      //   btns: [//按钮组
      //     {
      //       name: "查看详情",
      //       funcName:'seeDetail'
      //     },
      //     {
      //       name: "取消收藏",
      //       funcName:'cancelColl'
      //     }
      //   ],
      //   table_selection: false,  //是否显示选择按钮
      //   table_detail: [ //table详情
      //     {
      //       prop: "name",
      //       label: "技术名称",
      //       width:"100px"
      //     }
      //   ],
      //   layerpageinfo: { //分页
      //       pageNo: 0,
      //       total: 0,
      //       pageSize: 10,
      //       hide: true   //是否隐藏分页
      //   }
      // }
    };
  },
  mounted() {},
  methods: {
    /**表格内按钮点击*/

    handleClick(row, btn, index) {
      // console.log(index)
      this.$emit("btnClick", {
        row: row,
        btnFuncName: btn.funcName,
        btnName: btn.name,
        tableName: this.tableObj.tableName,
        dataIndex: index
      });
    },
    /**改变分页的条数pagesize */

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.$emit("changePagesize", {
        val: val,
        tableName: this.tableObj.tableName
      });
    },
    /**改变分页pageNo */

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.$emit("changePageNo", {
        val: val,
        tableName: this.tableObj.tableName
      });
    }
  }
};
</script>

<style lang="scss">
.my_table_components {
  .block {
    padding-top: 30px;
    display: flex;
    justify-content: center;
  }

  .my-table {
    border: 1px solid #e5e8ed;
    border-bottom: 0;
    .table_btn {
      font-size: 12px !important;
      color: #117eff !important;
      cursor: pointer;
    }
    .ellipsis-text {
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
}
</style>
